import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_ANALYTICS',
    'FETCH_ANALYTICS_V2',
    'FETCH_ANALYTICS_SUCCESS',
    'FETCH_ANALYTICS_V2_SUCCESS'
], 'ANALYTICS');

// Action Creators
export const fetchAnalytics = createAction(actions.FETCH_ANALYTICS);
export const fetchAnalyticsV2 = createAction(actions.FETCH_ANALYTICS_V2);
export const fetchAnalyticsSuccess = createAction(actions.FETCH_ANALYTICS_SUCCESS);
export const fetchAnalyticsV2Success = createAction(actions.FETCH_ANALYTICS_V2_SUCCESS);

// Reducers
const initialState = {
    northStar: [],
    northStarV2: {}
};

export default handleActions({
    [actions.FETCH_ANALYTICS_SUCCESS]: (state, action) => {
        const updatedData = {
            northStar: { $set: action.payload }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_ANALYTICS_V2_SUCCESS]: (state, action) => {
        const updatedData = {
            northStarV2: { $set: action.payload }
        };
        return update(state, updatedData);
    },
}, initialState);



// WEBPACK FOOTER //
// ./src/services/analytics/duck.js